require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-flat-stomach-or-strong-stomach.json") })
        }
      }, "path---blog-flat-stomach-or-strong-stomach");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-flat-stomach-or-strong-stomach!./.cache/json/blog-flat-stomach-or-strong-stomach.json
// module id = 288
// module chunks = 231608221292675